import React, {useEffect, useState} from "react";
import {X} from "lucide-react";

export const Footer = () => {
    const [isPolicyModalOpen, setIsPolicyModalOpen] = useState(false);

    useEffect(() => {
        if (!isPolicyModalOpen) {
            return;
        }

        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";

        const handleEscape = (event) => {
            if (event.key === "Escape") {
                setIsPolicyModalOpen(false);
            }
        };

        document.addEventListener("keydown", handleEscape);

        return () => {
            document.removeEventListener("keydown", handleEscape);
            document.body.style.overflow = previousOverflow;
        };
    }, [isPolicyModalOpen]);
    return (
        <footer className='footer-section' id='footer'>
            <div className='section-content footer-main'>
                <div className='footer-brand'>
                    <h3 className='footer-brand-title'>Saisha Spiritual Touch </h3>
                    <p className='footer-brand-text'>
                    Your Wellness Journey Starts Here • Relax • Restore • Reconnect • Monday through Sunday
                    </p>
                </div>

                <div className='footer-links'>
                    <h4 className='footer-links-title'>Quick Links</h4>
                    <ul>
                        <li><a href='#about'>Meet Saisha</a></li>
                        <li><a href='#services'>Services</a></li>
                        <li>
                            <button type='button' className='footer-policy-link' onClick={() => setIsPolicyModalOpen(true)}>
                                Policy
                            </button>
                        </li>
                        <li><a href='#contact'>Contact</a></li>
                    </ul>
                </div>
            </div>

            <div className='section-content footer-bottom'>
                <p className='copyright-text'>
                    © Saisha Spiritual Touch LLC. All rights reserved.
                </p>
                <a className='byline-text' href='https://sweetestadsmedia.com/'>
                    Created by Sweetest Interactive AdsMedia
                </a>
            </div>

            {isPolicyModalOpen && (
                <div className='policy-modal-backdrop' onClick={() => setIsPolicyModalOpen(false)}>
                    <div
                        className='policy-modal'
                        role='dialog'
                        aria-modal='true'
                        aria-labelledby='policy-modal-title'
                        onClick={(event) => event.stopPropagation()}
                    >
                        <button
                            type='button'
                            className='policy-modal-close'
                            aria-label='Close cancellation policy'
                            onClick={() => setIsPolicyModalOpen(false)}
                        >
                            <X/>
                        </button>

                        <h3 id='policy-modal-title' className='policy-modal-title'>Cancellation Policy</h3>

                        <div className='policy-modal-content'>
                            <p>Cancellation Policy Unanticipated events happen occasionally in everyone’s life. To be effective and fair to all clients, I have the following policies in place for all clients.</p>
                            <p>48-Hour advance notice is required when cancelling an appointment If you are unable to give 48 hours advance notice you will be charged the full amount of your appointment. This amount must be paid prior to your next scheduled appointment. By giving me 48 hour’s notice, I can reschedule your appointment and free up your original time for another client.</p>
                            <p>Late Arrivals Your session is scheduled to begin at the appointed time. If you arrive late, your session will be shortened to accommodate the next client. Depending upon how late you arrive, I will determine if there is enough time remaining to complete any treatment. Regardless of the length of the treatment, you will be charged the full amount of your appointment.</p>
                            <p>No-Show If you forget or consciously choose to skip your appointment for any reason, you will be considered a “no-show.” You will be charged the full amount of your appointment. This amount must be paid prior to your next scheduled appointment.</p>
                           <p> I offer therapeutic massage ONLY. Any illicit or sexually suggestive remarks or advances made by client will result in immediate termination of the session, law enforcement will be notified and YOU will be liable for payment of the scheduled appointment. </p>
                        </div>
                    </div>
                </div>
            )}
        </footer>
    )
}
